export const UPDATE_CUSTOMER_DETAIL = 'UPDATE_CUSTOMER_DETAIL' // 增量更新CustomerDetail对象
export const CLEAR_CUSTOMER_DETAIL = 'CLEAR_CUSTOMER_DETAIL' // 清空CustomerDetail对象
export const UPDATE_LOTTERY_CUSTOMER_DETAIL = 'UPDATE_LOTTERY_CUSTOMER_DETAIL' // 增量更新 Lottery CustomerDetail对象
export const CLEAR_LOTTERY_CUSTOMER_DETAIL = 'CLEAR_LOTTERY_CUSTOMER_DETAIL' // 清空 Lottery Customer Detail对象



// WEBPACK FOOTER //
// ./src/store/module/mutation-types.js